import script from "./us.vue?vue&type=script&setup=true&lang=js"
export * from "./us.vue?vue&type=script&setup=true&lang=js"

import "./us.vue?vue&type=style&index=0&id=0083437c&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0083437c"]])

export default __exports__